import { castEnum } from "../../../../utils/CommonUtils";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class DocsBlockBehavior {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        var _a, _b, _c, _d;
        this.dataType = castEnum(model.dataType);
        this.items = model.items
            ? {
                numberOfItems: (_a = model.items.numberOfItems) !== null && _a !== void 0 ? _a : 0,
                allowLinks: (_b = model.items.allowLinks) !== null && _b !== void 0 ? _b : false,
                newItemLabel: (_c = model.items.newItemLabel) !== null && _c !== void 0 ? _c : null,
            }
            : null;
        this.entities = model.entities
            ? {
                selectionType: castEnum(model.entities.selectionType),
                maxSelected: (_d = model.entities.maxSelected) !== null && _d !== void 0 ? _d : 0,
            }
            : null;
    }
}
